export default __webpack_public_path__ + "static/media/alarm.6634d812.svg";